export enum enumCompanyPaymentType {
  INSTANT = 0,
  MONTHLY = 1,
}
